import moment from 'moment'

import { ProfitHeader, ProfitLine, ReportDateField } from './types'

const CURRENCY_SYMBOL = 'Rs'

export const formatPKR = (
  value: number | null | undefined,
  options?: { withCode?: boolean; minimumFractionDigits?: number },
) => {
  const { withCode = true, minimumFractionDigits = 2 } = options || {}
  const safeValue = Number.isFinite(Number(value)) ? Number(value) : 0
  const formatted = safeValue
    .toFixed(Math.max(0, minimumFractionDigits))
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return withCode ? `${CURRENCY_SYMBOL} ${formatted}` : formatted
}

export const formatCount = (value: number) =>
  new Intl.NumberFormat('en-US').format(Number(value ?? 0))

export const resolveReportDate = (dateInput?: ReportDateField | null) => {
  if (!dateInput) return ''
  return typeof dateInput === 'object' ? dateInput.date || '' : dateInput
}

export const formatReportDate = (dateInput?: ReportDateField | null) => {
  const dateStr = resolveReportDate(dateInput)
  if (!dateStr) return '--'
  const date = moment(
    dateStr.includes(' ') ? dateStr.replace(' ', 'T') : dateStr,
  )
  return date.isValid() ? date.format('MMMM D, YYYY') : dateStr
}

export const formatReportDateMeta = (dateInput?: ReportDateField | null) => {
  const dateStr = resolveReportDate(dateInput)
  if (!dateStr) return ''
  const date = moment(
    dateStr.includes(' ') ? dateStr.replace(' ', 'T') : dateStr,
  )
  return date.isValid() ? date.format('ddd').toUpperCase() : ''
}

export const getHeaderTotalSale = (header: ProfitHeader) =>
  Number(header.total_sale ?? 0)

export const getHeaderTotalCost = (header: ProfitHeader) =>
  Number(header.total_cost ?? 0)

export const getProfitMargin = (header: ProfitHeader) => {
  const sale = getHeaderTotalSale(header)
  if (sale <= 0) return 0
  return (Number(header.total_simple_profit ?? 0) / sale) * 100
}

export const getLineTotalSale = (line: ProfitLine) =>
  Number(line.total_sale ?? line.sale_price ?? 0)

export const getLineTotalCost = (line: ProfitLine) =>
  Number(line.total_cost ?? line.purchase_price ?? 0)

export const getLineSalePrice = (line: ProfitLine) => {
  if (line.sale_price !== null && line.sale_price !== undefined) {
    return Number(line.sale_price)
  }
  if ((line.qty_sold ?? 0) > 0) {
    return getLineTotalSale(line) / Number(line.qty_sold)
  }
  return 0
}

export const getLinePurchasePrice = (line: ProfitLine) => {
  if (line.purchase_price !== null && line.purchase_price !== undefined) {
    return Number(line.purchase_price)
  }
  if ((line.qty_sold ?? 0) > 0) {
    return getLineTotalCost(line) / Number(line.qty_sold)
  }
  return 0
}
